// File: src/views/Contact.js

import React from 'react';
import styles from './Contact.module.css';
import ContactForm from '../components/contact/ContactForm';
import HubSpotMeetings from '../components/contact/HubSpotMeetings';

function Contact() {
  return (
    <main className={styles.page}>
      <ContactForm />
      <HubSpotMeetings />
    </main>
  );
}

export default Contact;